<div class="discover-companies">
  <div class="discover-companies__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'companies.discover.hero_title' | translate }}</h1>
      <p class="vacancy-hero__subtitle">{{ 'companies.discover.hero_subtitle' | translate }}</p>

      <div class="discover-companies__search-form">
        <div class="discover-companies__field">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
          <div class="discover-companies__field-content">
            <label>{{ 'shared.what' | translate }}</label>
            <input type="text" [(ngModel)]="searchTerm" [placeholder]="'companies.discover.placeholder' | translate" />
          </div>
        </div>
        <button class="discover-companies__submit" (click)="search()">{{ 'shared.search' | translate }}</button>
      </div>

      <p class="discover-companies__result-count" *ngIf="hasSearched">
        {{ companies.length }} {{ 'companies.discover.results_found' | translate }}
      </p>
    </div>
  </div>

  <div class="discover-companies__filters-bar">
    <div class="vacancy-container">
      <div class="vacancy-filters">
        <div>
          <label class="vacancy-filters__label">{{ 'companies.discover.filter_fields' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="fieldsOptions"
            [control]="fieldsControl"
            [placeholder]="'shared.all_fields' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onFieldsSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'companies.discover.filter_sectors' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="sectorsOptions"
            [control]="sectorsControl"
            [placeholder]="'companies.discover.filter_all_sectors' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onSectorsSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'companies.discover.filter_languages' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="languagesOptions"
            [control]="languagesControl"
            [placeholder]="'companies.discover.filter_all_languages' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onLanguagesSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'companies.discover.filter_size' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="sizesOptions"
            [control]="sizesControl"
            [placeholder]="'companies.discover.filter_all_sizes' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onSizesSelected($event)"
          ></lib-single-select-search>
        </div>
      </div>
    </div>
  </div>

  <div class="vacancy-container discover-companies__content">
    <div class="vacancy-grid">
      <bwc-company-card
        *ngFor="let company of visibleCompanies"
        [company]="company"
        [isFollowed]="isFollowed(company.id)"
        (followed)="toggleFollow($event)"
      ></bwc-company-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>
</div>
